export const BURGERMENU_PAGES = {
    responsible: 'Ansvarligt spil',
    security: 'Om NemID',
    terms: 'Regler & vilkår',
    about: 'Om Bet25 Casino',
    payback: 'Vinderchancer',
}
